import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { moveFormatter } from "../../fomatters/BooleanFormatter";
import Crud from "../Crud";
import Sports from "../Sports";

/**
 * TABLE SYSTEMCOLORS
 */
function Teams() {
  const [sport, setSport] = useState();
  const onSportChanged = useCallback((sport) => {
    setSport(sport);
  }, []);

  return (
    <div className="flex flex-col gap-4 h-max">
      <div className="vertical-options">
        <Sports setIdSportOnMem={onSportChanged} />
      </div>
      <Crud
        title="Team"
        getUrl={() => `/Game/Team_GetList?idSport=${sport}`}
        // INSERT
        insertUrl={() => "/Game/Team_Insert"}
        insertParams={({ userId }, { teamName, longName }) => ({
          IdSport: sport,
          TeamName: teamName,
          LongName: longName,
          IdUser: Number(userId),
        })}
        // UPDATE
        updateUrl={() => "/Game/Team_Update"}
        updateParams={({ userId }, { idTeam, teamName, longName }) => ({
          IdTeam: idTeam,
          IdSport: sport,
          TeamName: teamName,
          LongName: longName,
          IdUser: Number(userId),
        })}
        // DELETE
        deleteUrl={() => "/Game/Team_Delete"}
        deleteParams={({ userId }, id) => ({
          IdTeam: id,
          IdUser: Number(userId),
        })}
      >
        <TableHeaderColumn
          visible="none"
          hiddenOnInsert
          autoValue={true}
          hidden
          isKey
          dataField="idTeam"
        >
          IdTeam
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="teamName"
          filter={{ type: "TextFilter", delay: 1000 }}
        >
          Team Name
        </TableHeaderColumn>
        <TableHeaderColumn dataField="idSport" hiddenOnInsert autoValue={true}>
          Sport
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="longName"
          filter={{ type: "TextFilter", delay: 1000 }}
        >
          Long Name
        </TableHeaderColumn>
      </Crud>
    </div>
  );
}

export default Teams;
